var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M0 133.106V0H177.149V133.106", fill: "#5996E4" },
      }),
      _c("path", {
        attrs: {
          d: "M163 66.5005C163 103.227 129.869 133 89.0002 133C48.1311 133 15 103.227 15 66.5002C15 29.7735 48.1307 0.000277851 88.9995 0C129.869 0 163 29.7731 163 66.5005Z",
          fill: "#2464C5",
        },
      }),
      _c("path", {
        attrs: {
          d: "M125 66.5C125 85.0011 108.882 99.9995 89 99.9995C69.1174 99.999 52.9995 85.0011 53 66.4995C53 47.9984 69.1174 33.0005 89 33C108.882 33 125 47.9984 125 66.5Z",
          fill: "#5996E4",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }